import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import IconButton from 'components/IconButton/IconButton';

import type IKeywordItem from './interfaces/IKeywordItem';

import styles from './scss/KeywordItem.module.scss';

function KeywordItem({ keyword, onRemove, className }: IKeywordItem) {
  const handleRemove = () => {
    onRemove(keyword);
  };

  return (
    <div className={`${styles.keyword} ${className}`}>
      <span>{keyword}</span>
      <IconButton
        className={styles.iconButton}
        icon={<CloseIcon />}
        onClick={handleRemove}
      />
    </div>
  );
}

export default KeywordItem;
